import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './BetaAdminFeedbackPage.css';

const BetaAdminFeedbackPage = () => {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const response = await api.get('/admin/feedback');
        setFeedback(response.data.feedback || []);
      } catch (err) {
        setError('Failed to load feedback');
      } finally {
        setLoading(false);
      }
    };
    fetchFeedback();
  }, []);

  if (loading) return <div className="loading">Loading feedback...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="beta-admin-feedback">
      <h2>Beta Feedback</h2>
      {feedback.length === 0 ? (
        <p>No feedback yet.</p>
      ) : (
        <div className="beta-admin-feedback__list">
          {feedback.map(item => (
            <div key={item._id} className="beta-admin-feedback__card">
              <div className="beta-admin-feedback__header">
                <span className="tag">{item.type}</span>
                <span className={`status status-${item.status}`}>{item.status}</span>
              </div>
              <h4>{item.title}</h4>
              <p>{item.body}</p>
              {item.meta?.platform && (
                <small>{item.meta.platform} • {item.meta.appVersion || 'unknown'}</small>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BetaAdminFeedbackPage;
